const voices = [
  {
    name: 'default',
    icon: '//cloakbrand.com/cdn/shop/files/CloakFace_e54aa1c0-54d6-4e4a-af83-939c936a4ef5.svg?height=64&v=1752866093&width=64'
  },
  {
    name: 'meow',
    icon: '//cloakbrand.com/cdn/shop/files/CatFace1.svg?height=64&v=1752866145&width=64',
    initFunction: () => {
      meowify();
      console.log('> Content meowified!');
    },
    cleanupFunction: () => {
      restoreMeowifiedText();
      console.log('> Content de-meowified.');
    }
  },
];

let currentVoice = getVoiceFromName(sessionStorage.getItem("voice")) || voices[0];
sessionStorage.setItem("voice", currentVoice.name);
let changingVoice = false;
const voiceCooldown = 100; // milliseconds
let voiceChangeTime = null;

function getVoiceFromName(name) {
  return voices.find(voice => voice.name === name);
}

function loadIcons() {
  voices.forEach(voice => {
    if (voice.icon) {
      const img = new Image();
      img.src = voice.icon;
      img.onload = () => img.remove();
    }
  });
}

function replaceVoiceIcon(voice) {
  if (voice.name == currentVoice.name) return;
  const voiceIconEl = document.querySelector('#voice-icon');
  const defaultIcon = '//cloakbrand.com/cdn/shop/files/CloakFace_e54aa1c0-54d6-4e4a-af83-939c936a4ef5.svg?height=64&v=1752866093&width=64';
  if (voiceIconEl && voice.icon) {
    voiceIconEl.src = voice.icon.replace(/^\/\/[^\/]*/g, '');
  } else if (voiceIconEl && defaultIcon) {
    voiceIconEl.src = defaultIcon.replace(/^\/\/[^\/]*/g, '');
  }
  if (voiceIconEl) {
    voiceIconEl.alt = `${voice.name.charAt(0).toUpperCase() + voice.name.slice(1)} Voice`;
  }
  
  const now = Date.now();
  voiceChangeTime = now;
  voiceIconEl.style.animation = 'none';
  requestAnimationFrame(() => {
    voiceIconEl.style.animation = 'subtleShake 2s ease-in-out';
    setTimeout(() => {
      if (voiceChangeTime !== now) return;
      voiceIconEl.style.animation = 'none';
    }, 2000);
  });
}

function changeVoice(newVoice = voices[(voices.indexOf(currentVoice) + 1) % voices.length]) {
  if (changingVoice) return;
  changingVoice = true;
  const prevVoice = currentVoice;
  sessionStorage.setItem("voice", newVoice.name);

  if (prevVoice.name != newVoice.name && prevVoice.cleanupFunction) {
    prevVoice.cleanupFunction();
  }

  document.body.setAttribute('data-voice', newVoice.name);

  if (newVoice.initFunction) {
    newVoice.initFunction();
  }

  replaceVoiceIcon(newVoice);

  currentVoice = newVoice;
  const currentVoiceEl = document.querySelector('#current-voice');
  if (currentVoiceEl) {
    currentVoiceEl.textContent = `Set to ${currentVoice.name.charAt(0).toUpperCase() + currentVoice.name.slice(1)}`;
  }
  setTimeout(() => changingVoice = false, voiceCooldown);
}

const meowUpdater = new MutationObserver((mutationsList) => {
  changeVoice(currentVoice);
});

document.addEventListener('DOMContentLoaded', () => {
  changeVoice(currentVoice);

  meowUpdater.observe(document.body, {
    childList: true,
    subtree: true
  });
});